export const PAYMENT_TERMS = {
  DUE_ON_RECEIPT: 'Due on Receipt',
}
